/** Delete a tenant user invitation. */
export const tenantUserInvitationDeleteSpec = {
    uri: '/t/[tenant]/user/invitation/[invitation]',
    method: 'DELETE',
};
